import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import Spacer from "../../Spacer";

export default memo(function ManualAudioResultRow({
  time,
  date,
  uploadFailed,
  manualAudioComplete,
  onClick,
}) {
  const { t } = useTranslation();

  return (
    <div className="w-full flex flex-col">
      <button
        type="button"
        onClick={onClick}
        className={[
          "w-full text-left py-2 flex-col items-center gap-4 bg-transparent",
          onClick ? "cursor-pointer" : "cursor-default",
        ].join(" ")}
        disabled={!onClick}
      >
        <div>
          <p className="muted-text">
            {time} {date}
          </p>
        </div>

        <div className="flex-1 min-w-0 flex flex-col gap-1">
          <div
            className={[
              "title-text text-center whitespace-nowrap",
              uploadFailed
                ? "!text-greyscale-3"
                : manualAudioComplete
                  ? "!text-primary"
                  : "!text-greyscale-3",
            ].join(" ")}
          >
            {uploadFailed
              ? t("result.uploadFailedTitle", "Upload failed")
              : manualAudioComplete
                ? t(
                    "result.manualAudio.completeTitle",
                    "Manual audio recording complete",
                  )
                : t("result.wait", "Please wait for results")}
          </div>
        </div>
      </button>

      <Spacer />
    </div>
  );
});
